export default "__VITE_ASSET__D5y7dSCo__"